(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fblog%2Findex.tsx&page=%2Fblog!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__("./src/pages/blog/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Blog/BlogPost.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ BlogPost; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 11 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./node_modules/react-icons/tb/index.esm.js
var tb_index_esm = __webpack_require__("./node_modules/react-icons/tb/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkWrapper.tsx
var LinkWrapper = __webpack_require__("./src/components/Elements/LinkElements/LinkWrapper.tsx");
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 112 modules
var react_markdown = __webpack_require__("./node_modules/react-markdown/lib/react-markdown.js");
;// CONCATENATED MODULE: ./src/components/Blog/BlogPostMdComponents.tsx


const p = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        noOfLines: 3,
        children: children
    });
};
const postComponent = {
    p
};

;// CONCATENATED MODULE: ./src/components/Blog/BlogPost.tsx










const BlogPost = (props)=>{
    const { post , ...rest } = props;
    var _timestamp, _excerpt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* LinkWrapper */.g, {
        href: "/blog/".concat(post.digest),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            display: "flex",
            flexDir: "column",
            rounded: "lg",
            border: "1px",
            borderColor: "gray.200",
            bg: "white",
            transition: "all 0.3s",
            _hover: {
                transform: "scale(1.02)"
            },
            _dark: {
                bg: "gray.700",
                borderColor: "whiteAlpha.400"
            },
            overflowX: "hidden",
            cursor: "pointer",
            ...rest,
            children: [
                post.cover_image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    h: "52",
                    src: post.cover_image.replace("\\_", "_"),
                    loading: "lazy",
                    alt: post.title,
                    width: "full",
                    imgH: Constants/* IMAGE_BOX_SIZE */.xh,
                    imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    h: "fit-content",
                    px: "3",
                    pt: 4,
                    pb: 7,
                    flexDir: "column",
                    flex: "auto",
                    gap: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            gap: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Avatar */.qE, {
                                    address: post.contributor,
                                    size: 20,
                                    alt: "unknown"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    _dark: {
                                        color: "whiteAlpha.800"
                                    },
                                    children: new Date(((_timestamp = post.timestamp) !== null && _timestamp !== void 0 ? _timestamp : 0) * 1000).toDateString()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            flexGrow: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    align: "center",
                                    mb: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "lg",
                                        fontWeight: "semibold",
                                        noOfLines: 3,
                                        children: post.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                    components: postComponent,
                                    children: (_excerpt = post.excerpt) !== null && _excerpt !== void 0 ? _excerpt : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* LinkWrapper */.g, {
                            href: "/blog/".concat(post.digest),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                gap: 2,
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "sm"
                                        },
                                        textAlign: "center",
                                        color: "brand.500",
                                        children: "Read Post"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tb_index_esm/* TbArrowUpRight */.uo1, {
                                        color: "#FF5CAA"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ "./src/pages/blog/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Blog": function() { return /* binding */ blog_Blog; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 6 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./src/components/Blog/BlogPost.tsx + 1 modules
var BlogPost = __webpack_require__("./src/components/Blog/BlogPost.tsx");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");
;// CONCATENATED MODULE: ./src/components/SEO/Blog.tsx



const BlogHeader = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("blog");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: t("blog"),
        description: t("blogSEODescription"),
        canonical: "https://iq.wiki/blog",
        openGraph: {
            title: t("blog"),
            description: t("blogSEODescription")
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWIKI",
            site: "IQWiki"
        }
    });
};
/* harmony default export */ var Blog = (BlogHeader);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/image/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Blog/BlogPageHeader.tsx




const BlogPageHeader = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("blog");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        pt: {
            base: 8,
            md: 14,
            lg: 24
        },
        pb: {
            base: 28,
            md: 32,
            lg: 48
        },
        w: {
            md: "80%",
            base: "95%"
        },
        mx: "auto",
        flexDir: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontSize: {
                    xl: "md",
                    base: "sm"
                },
                textAlign: "center",
                color: "brand.500",
                children: t("blog")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                fontSize: {
                    md: "4xl",
                    base: "2xl",
                    xl: "5xl"
                },
                mb: 4,
                fontWeight: "600",
                color: "gray.800",
                children: t("blogHeading")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontSize: {
                    xl: "lg",
                    base: "md"
                },
                textAlign: "center",
                maxW: "743px",
                color: "gray.600",
                children: t("blogDescription")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                my: 4,
                minWidth: 100,
                gap: 4,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        fontSize: {
                            xl: "lg",
                            base: "md"
                        },
                        color: "gray.600",
                        children: t("blogDescription2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                                href: "https://mirror.xyz/0x3c1ccc207b3796D907B0024eD79fa2A11Af8D912",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                    src: "/images/logos/kr.svg",
                                    width: {
                                        base: 6,
                                        lg: 10
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                                href: "https://mirror.xyz/0xcd5Cc4F54C20C80aED2db81CBaf82153Fb95C1b1",
                                target: "_blank",
                                ml: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                    src: "/images/logos/cn.svg",
                                    width: {
                                        base: 6,
                                        lg: 10
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Blog_BlogPageHeader = (BlogPageHeader);

;// CONCATENATED MODULE: ./src/pages/blog/index.tsx






var __N_SSG = true;
const blog_Blog = (param)=>{
    let { blogEntries  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* chakra.div */.m$.div, {
                bgColor: "pageBg",
                my: -4,
                py: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        bgColor: "brand.50",
                        _dark: {
                            bgColor: "brand.100"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_BlogPageHeader, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
                        w: "min(90%, 1100px)",
                        mx: "auto",
                        position: "relative",
                        top: {
                            base: "-75px",
                            lg: -140
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* SimpleGrid */.MI, {
                            columns: {
                                base: 1,
                                md: 2,
                                lg: 3
                            },
                            spacingX: "5",
                            spacingY: "14",
                            children: blogEntries && blogEntries.length > 0 ? blogEntries.map((b, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPost/* BlogPost */.J, {
                                    post: b
                                }, i)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                                colSpan: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                    fontSize: "md",
                                    textAlign: "center",
                                    children: "No entries so far..."
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog = (blog_Blog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8907,9956,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fblog%2Findex.tsx&page=%2Fblog!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);